<template>
  <div :data-mode="props.mode"
    class="w-[calc(158.90px+0.0496*100vw)] p-4 data-[mode=swipe]:w-[calc(109.72px+0.1102*100vw)] data-[mode=default]:rounded-md data-[mode=default]:bg-white data-[mode=default]:shadow-[0px_1px_0px_1px_#f7fafc]">
    <div id="book" style="display: flex; flex-direction: column">
      <div class="mb-2 cursor-pointer drop-shadow-xl relative">
        <ProductCircleProccent v-if="item.special && item.special.proccent && (item.count ?? 0) > 0"
          class="absolute -left-[10px] top-[5%]" :item="item">
        </ProductCircleProccent>
        <div v-if="!available" class="relative z-10">
          <div class="absolute -rotate-12 bg-slate-400 p-1 text-sm text-white">нет в наличии</div>
        </div>

        <a @click="emit('image_touched', item)" :href="item.page_url" :target="props.cardTarget">
          <img :class="{ 'grayscale-[90%]': !available }"
            style="width: 100%; height: 100%; object-fit: contain; aspect-ratio: 3/4" :src="item.image" alt="" />
        </a>
      </div>
      <div class="text-left text-base leading-5 text-neutral-900 2xl:text-lg 2xl:leading-5">
        <p v-if="props.showBookName" class="mb-2 line-clamp-2">
          {{ item.name }}
        </p>
        <p v-if="props.showDescription" class="mb-2 line-clamp-4">
          {{ stripHtml(item.short_description ?? '').result }}
        </p>
        <div v-if="item.price > 0" class="flex flex-col flex-wrap justify-between gap-3 md:flex-row">

          <template v-if="item.special && (item.count ?? 0) > 0">
            <div class="text-xl font-semibold flex justify-between flex-1">
              <div>{{ item.special.price }}₽</div>
              <div class="text-neutral-500 line-through decoration-red-700">{{ item.price }}₽</div>
            </div>
          </template>
          <template v-else>
            <div class="text-xl font-semibold">{{ item.price }}₽</div>
          </template>

          <a v-if="available" :data-disabled="!available || props.loading"
            :href="item.in_bascet ? '/index.php?route=checkout/cart' : undefined" target="_blank" @click="() => {
              if (item.in_bascet) {
                return
              }
              if (props.loading) {
                return
              }
              if (!available) {
                return
              }
              emit('to_basket', item)
            }
              " :class="{
                ['bg-blue-800']: item.in_bascet,
                ['text-white']: item.in_bascet,
                ['bg-slate-500 text-white']: !available,
                ['data-[disabled=true]:cursor-not-allowed']: !item.in_bascet
              }"
            class="flex cursor-pointer items-center justify-center rounded-md bg-blue-50 px-2 text-sm text-blue-600 hover:bg-blue-200">
            <template v-if="item.in_bascet"> В корзине </template>
            <template v-else> В корзину </template>
            <span v-if="props.loading" class="loading loading-spinner loading-xs"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { type BookItem } from '@/types/book_item'
import { stripHtml } from 'string-strip-html'
import { computed } from 'vue'
import ProductCircleProccent from '@/components/product/ProductCircleProccent.vue';

const props = withDefaults(
  defineProps<{
    item: BookItem
    loading?: boolean
    showBookName?: boolean
    showDescription?: boolean
    mode?: 'swipe' | 'default'
    cardTarget?: '_blank' | '_self'
  }>(),
  {
    mode: 'default',
    loading: false,
    showBookName: true,
    showDescription: false,
    cardTarget: '_self'
  }
)

const emit = defineEmits<{
  (e: 'to_basket', item: BookItem): void
  (e: 'in_basket', item: BookItem): void
  (e: 'image_touched', item: BookItem): void
}>()

const available = computed(() => {
  if (!props.item.count) {
    return false
  }
  if (props.item.count <= 0) {
    return false
  }
  return true
})
</script>
